import { useId } from 'react';

const StarDefaultIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const uid = useId();
  const id_0 = `paint0_radial_511_46_${uid}`;
  const id_1 = `paint1_linear_511_46_${uid}`;

  return (
    <svg {...props} viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.2834 1.07023L16.8728 6.60015C17.0675 7.01666 17.4435 7.30466 17.8795 7.37107L23.8568 8.28582C24.9529 8.4538 25.3903 9.87687 24.5969 10.6929L20.2756 15.133C19.9595 15.4577 19.8155 15.925 19.8901 16.3838L20.8781 22.4602C21.0781 23.6927 19.8555 24.6329 18.8074 24.0527L13.6234 21.1797C13.234 20.9637 12.77 20.9637 12.382 21.1797L7.20187 24.0498C6.15249 24.6315 4.92574 23.6898 5.1271 22.4545L6.1152 16.3838C6.18993 15.925 6.04584 15.4577 5.72983 15.133L1.4084 10.6929C0.613717 9.87687 1.05097 8.4538 2.14833 8.28582L8.12581 7.37107C8.56054 7.30466 8.93655 7.01666 9.13256 6.60015L11.722 1.07023C12.2433 -0.0521374 13.758 -0.0521374 14.2834 1.07023Z"
        fill="#EDCAFF"
        fillOpacity="0.02"
      />
      <path
        d="M14.2834 1.07023L16.8728 6.60015C17.0675 7.01666 17.4435 7.30466 17.8795 7.37107L23.8568 8.28582C24.9529 8.4538 25.3903 9.87687 24.5969 10.6929L20.2756 15.133C19.9595 15.4577 19.8155 15.925 19.8901 16.3838L20.8781 22.4602C21.0781 23.6927 19.8555 24.6329 18.8074 24.0527L13.6234 21.1797C13.234 20.9637 12.77 20.9637 12.382 21.1797L7.20187 24.0498C6.15249 24.6315 4.92574 23.6898 5.1271 22.4545L6.1152 16.3838C6.18993 15.925 6.04584 15.4577 5.72983 15.133L1.4084 10.6929C0.613717 9.87687 1.05097 8.4538 2.14833 8.28582L8.12581 7.37107C8.56054 7.30466 8.93655 7.01666 9.13256 6.60015L11.722 1.07023C12.2433 -0.0521374 13.758 -0.0521374 14.2834 1.07023Z"
        fill={`url(#${id_0})`}
        fillOpacity="0.1"
      />
      <path
        d="M12.1094 1.27161C12.4495 0.540171 13.3993 0.491922 13.8196 1.13511L13.897 1.27326L16.4861 6.80322C16.7439 7.35466 17.2416 7.73441 17.8174 7.82233V7.82318L23.7948 8.7381C24.4915 8.84483 24.7933 9.69775 24.3871 10.2577L24.2964 10.3652L19.9752 14.8049C19.5833 15.2076 19.3904 15.7771 19.4494 16.3477L19.465 16.4618L20.4526 22.5377C20.583 23.3418 19.8425 23.9708 19.1455 23.7115L19.0072 23.6478L13.8235 20.7749C13.3409 20.5072 12.771 20.4904 12.2781 20.7252L12.1812 20.7749L7.00143 23.6453C6.31261 24.027 5.51843 23.4701 5.53731 22.6907L5.55219 22.5319L6.54046 16.4618C6.63326 15.8919 6.47118 15.3117 6.10613 14.8876L6.03037 14.8049L1.70913 10.3652C1.20657 9.8492 1.43215 8.9713 2.07554 8.76953L2.20992 8.7381L8.18738 7.82318C8.72651 7.74084 9.19692 7.40075 9.46717 6.90496L9.51869 6.80407L9.51949 6.80322L12.1086 1.27326L12.1094 1.27161Z"
        stroke={`url(#${id_1})`}
        strokeWidth="1.07895"
      />
      <defs>
        <radialGradient
          id={id_0}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0022 22.9207) scale(22.6437 22.6436)"
        >
          <stop stopColor="#DB92FF" />
          <stop offset="0.68" stopColor="#EDCAFF" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id={id_1}
          x1="13.3239"
          y1="0.228483"
          x2="13.3239"
          y2="24.2285"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#211B3C" />
          <stop offset="0.55" stopColor="#40366A" />
          <stop offset="1" stopColor="#211B3C" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StarDefaultIcon;
